import type { FormikHelpers } from 'formik/dist/types'
import { useLocation } from 'react-router-dom'

import { useCurrentShop } from '@modules/Dashboard/hooks/useCurrentShop'

import type { FormValues } from '../Domain.types'
import { useGetSlugAvailabilityMutation, useInternalDomain } from '../modules/InternalDomain'
import { useUpdateSlugMutation } from '../queries/useUpdateSlugMutation'

export const useDomain = () => {
  const { currentShop } = useCurrentShop()
  const { updateSlugMutation } = useUpdateSlugMutation()
  const { getSlugAvailabilityMutation } = useGetSlugAvailabilityMutation()
  const location = useLocation()
  const { getDomainUrl } = useInternalDomain()

  const initialValues: FormValues = {
    internalDomain: currentShop?.internalDomain?.split('-shop')[0] || '',
  }

  const handleSubmit = async (values: FormValues, formik: FormikHelpers<FormValues>) => {
    if (initialValues.internalDomain !== values.internalDomain) {
      const slugAvailability = await getSlugAvailabilityMutation.mutateAsync([
        { text: values.internalDomain },
      ])

      if (slugAvailability.result.type === 'AVAILABLE') {
        await updateSlugMutation.mutateAsync([{ slug: values.internalDomain }])

        formik.resetForm({ values })

        // NOTE: we need to wait for the form to finish submit before redirecting
        setTimeout(() => {
          window.location.href = `https://${getDomainUrl(values.internalDomain)}${location.pathname}`
        })
      }
    }

    return Promise.resolve()
  }

  return {
    initialValues,
    handleSubmit,
  }
}
